<template>
  <div class="PaymentRecord">
    <!-- 缴费记录复核 -->
    <!--出纳页面 充值记录审批 -->
    <el-row>
      <el-form :inline="true" :model="quertForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-autocomplete v-model.trim="quertForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
            :fetch-suggestions="querySearchAsync" @select="handleOlderSelect" style="width: 200px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="quertForm.timevalue" unlink-panels type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="queryTable">查询</el-button>
          <!-- <el-button type="warning" icon="el-icon-plus" plain @click="oldCharge">缴费</el-button> -->
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table :data="tableData" :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }" :cell-style="{ 'text-align': 'center', 'font-size': '15px' }" :row-style="tableRowStyle"
        style="width: 100%">
        <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
        <el-table-column prop="oldIdCard" label="身份证号" width="180px" align="center"></el-table-column>
        <el-table-column prop="projectType" label="缴费方式" align="center" :formatter="formattype2"></el-table-column>
        <el-table-column prop="projectName" label="费用项目" align="center"></el-table-column>
        <el-table-column prop="ticket" label="票据号" align="center"></el-table-column>
        <el-table-column prop="consumptionFee" label="缴费金额" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="缴费时间" width="180px" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80px" :formatter="formatStatus"></el-table-column>

        <el-table-column prop="option" label="详情" width="100px" align="center">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              :disabled="scope.row.status != 0"
              plain
              @click="approve(scope.row)"
              >审批</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination class="fenye" background layout="total,prev, pager, next" :total="total" :current-page.sync="pageNum"
      @current-change="changePage" align="center"></el-pagination>

    


    <el-dialog
      title="确认缴费审核通过？"
      center
      width="380px"
      :visible.sync="enterDialogVisible"
    >
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="enterClick(2)"
          >不通过</el-button
        >
        <el-button type="primary" :loading="btnLoding"  @click="enterClick(1)"
          >通  过</el-button
        >
      </span>
    </el-dialog>


  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      tableData: [], //老人列表数据
      quertForm: {
        oldName: "", //搜索查询老人
        oldIdCard: "", //搜索查询老人身份证
      },
      dialogChargeVisible: false,
      formLabelWidth: "100px",
      enterDialogVisible:false,
      btnLoding:false,
      chargeForm: {},
      approveItem:{},
      chargeLoading: false,
      //分页
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      checkBill: [],
    };
  },
  methods: {
     /* 
   模糊查询老人
   */
   querySearchAsync2(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    formatStatus(row){
      if (row.status == 2){
        return '未通过';
      }else if(row.status == 1){
        return '已通过';
      }else{
        return '未审核';
      }
    },
    formattype2(row){
      if (row.type == 5){
        if (row.projectType == "1"){
          return "现金支付";
        }else if (row.projectType == "2"){
          return "刷卡支付";
        }else if (row.projectType == "3"){
          return "移动支付";
        }else{
          return row.projectType;
        }
      }else{
        return row.projectType;
      }
    },
    approve(row){
      this.enterDialogVisible = true;
      this.btnLoding = false;
      this.approveItem = row;
    },
    enterClick(status){
      this.btnLoding = true;
      let params = {
        id:this.approveItem.id,
        status : status
      }
      this.$postJson("fmc/account/rechargeApproval", params).then((res) => {
          this.queryPayList();
          this.btnLoding = false;
          this.enterDialogVisible = false;
          this.$message({ message: "审批完成", type: "success" });
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect2(item) {
      this.chargeForm.oldmanId = item.oldmanId;
      this.chargeForm.oldIdCard = item.oldIdCard;
    },
    /* 
     模糊查询老人
     */
    inputChange1(val) {
      //限制输入数字和两位小数;
      this.chargeForm.rechargePrice = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    inputChange2(val) {
      this.chargeForm.giftFee = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    oldCharge() {
      this.dialogChargeVisible = true;
      this.chargeForm = {
        oldmanId: "",
        rechargePrice: "",
        giftFee: "",
        chargeType: "",
        chargeDay: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      }
    },
    submitForm() {
      console.log(this.chargeForm);
      if (this.chargeForm.oldmanId == null || this.chargeForm.oldmanId == '') {
        return;
      }
      if (this.chargeForm.rechargePrice == null || this.chargeForm.rechargePrice == '') {
        return;
      }
      if (this.chargeForm.chargeType == null || this.chargeForm.chargeType == '') {
        return;
      }
      this.chargeLoading = true;
      console.log(this.chargeForm);
      let typeName = "";
      if (this.chargeForm.chargeType == '1') {
        typeName = "现金支付";
      } else if (this.chargeForm.chargeType == '2') {
        typeName = "刷卡支付";
      } else {
        typeName = "移动支付";
      }
      var params = {
        oldmanId: this.chargeForm.oldmanId,
        rechargePrice: this.chargeForm.rechargePrice,
        giftFee: this.chargeForm.giftFee,
        chargeType: this.chargeForm.chargeType,
        typeName: typeName,
        chargeDay: this.chargeForm.chargeDay
      }
      this.$postJson("fmc/account/recharge", params).then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          this.chargeLoading = false;
          this.dialogChargeVisible = false;
          this.queryPayList();
          this.$message({ message: "缴费成功", type: "success" });
        } else {
          this.chargeLoading = false;
          this.$message({ message: res.message, type: "error" });
        }
      });

    },
    /* 
     模糊查询老人
     */
    querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.quertForm.oldmanId = item.oldmanId;
      this.quertForm.oldIdCard = item.oldIdCard;
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //查询欠费列表
    queryPayList() {
      if (this.quertForm.oldName == null || this.quertForm.oldName == '') {
        this.quertForm.oldmanId = null;
      }
      let param = {
        oldmanId: this.quertForm.oldmanId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("fmc/account/queryRechargeRecord", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
      });
    },
    //回车enter回车查询
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    //搜索查询搜索查询
    queryTable() {
      this.pageNum = 1;
      this.queryPayList();
    },
    //分页
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.queryPayList(); //刷新欠费列表的数据
  },
};
</script>
<style lang="scss" scoped>
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}

.are {
  color: #369a52;
}

.no {
  color: red;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
  